import * as React from "react";
import PropTypes from "prop-types";
import {
  FluentProvider,
  webLightTheme,
  AvatarGroup,
  AvatarGroupItem,
  AvatarGroupPopover,
  makeStyles,
  partitionAvatarGroupItems,
} from "@fluentui/react-components";
import { getNamesArray } from "../../../../util/array-helpers";

const useStyles = makeStyles({
  root: {
    display: "grid",
    flexDirection: "column",
    rowGap: "10px",
    color: "brand",
  },
});

const DynamicFieldsAvatarGroup = ({ members }) => {
  const avatarGroupRef = React.useRef(null);
  const [popoverOpened, setPopoverOpened] = React.useState(false);
  const maxItemsToShow = 3;  
  const limitedNamesArray = members.slice(0, maxItemsToShow);
  const top3PartitionedItems = partitionAvatarGroupItems({ items: limitedNamesArray });
  const styles = useStyles();

  const handleMouseEnter = () => {
    if (members.length > 0 && avatarGroupRef.current && !popoverOpened) {
      const popoverButton = avatarGroupRef.current.querySelector('button');
      if (popoverButton) {
        popoverButton.click();
        setPopoverOpened(true);
      }
    }
  };

  const handleMouseLeave = () => {
    setPopoverOpened(false);
  };

  return (
    <React.Fragment>
      { members.length > 0 ?
          <FluentProvider theme={webLightTheme}>
            <div
              className={styles.root}
              onMouseOver={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              onFocus={handleMouseEnter}
              ref={avatarGroupRef}
            >
              { members.length >= 3 ?
                <AvatarGroup layout="stack">
                  { top3PartitionedItems.inlineItems.map((name) => (
                    <AvatarGroupItem name={name.Name} key={name.Name} color={name.Type} />
                  ))}
                  { members.length >= 3 && (
                    <AvatarGroupPopover indicator="icon" className="popoverButton">
                      { members.map((name) => (
                        <AvatarGroupItem name={name.Name} key={name.Name} color={name.Type}/>
                      ))}
                    </AvatarGroupPopover>
                  )}
                </AvatarGroup>
              :
                <AvatarGroup layout="stack">
                  { members.map((name) => (
                    <AvatarGroupItem name={name.Name} key={name.Name} color={name.Type} />
                  ))}
                  { members.length >= 1 && (
                    <AvatarGroupPopover indicator="icon" className="popoverButton">
                      { members.map((name) => (
                        <AvatarGroupItem name={name.Name} key={name.Name} color={name.Type} />
                      ))}
                    </AvatarGroupPopover>
                  )}
                </AvatarGroup>
              }
            </div>
          </FluentProvider>
        :
          "-"
      }
    </React.Fragment>
  );
};

DynamicFieldsAvatarGroup.propTypes = {
  members: PropTypes.arrayOf(
    PropTypes.shape({
      Name: PropTypes.string.isRequired,
      Type: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default DynamicFieldsAvatarGroup;
